
<br>

<div style="width: 100%;">
    <table  mat-table matSort matSortActive="occurance" matSortDirection="asc" matSortDisableClear [dataSource]="dataSource" style="width: 100%;">
        <ng-container matColumnDef="occurance">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> Occurrence Date </th>
            <td mat-cell *matCellDef="let element">
                {{element.occurance| date:'MM/dd/yyyy'}}
            </td>
        </ng-container>
        <ng-container matColumnDef="code">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> Code </th>
            <td mat-cell *matCellDef="let element">
                {{element.code}}
            </td>
        </ng-container>
        <ng-container matColumnDef="description">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> Description </th>
            <td mat-cell *matCellDef="let element"> {{element.description}} </td>
        </ng-container>
        <ng-container matColumnDef="action">
            <mat-header-cell *matHeaderCellDef>Action</mat-header-cell>
            <mat-cell *matCellDef="let element">
                <button mat-icon-button color="primary" *ngIf="element.fileName;else elseBlock" (click)="download(element)">
                    <mat-icon>file_download</mat-icon>
                </button>     
                <ng-template #elseBlock>N/A</ng-template>              
            </mat-cell>
        </ng-container>  
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>
</div>
